import { render, staticRenderFns } from "./modalVoidOveride.vue?vue&type=template&id=2d77786a&scoped=true"
import script from "./modalVoidOveride.vue?vue&type=script&lang=js"
export * from "./modalVoidOveride.vue?vue&type=script&lang=js"
import style0 from "./modalVoidOveride.vue?vue&type=style&index=0&id=2d77786a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77786a",
  null
  
)

export default component.exports